export default "__VITE_ASSET__BF16CYEa__"